export default "__VITE_PUBLIC_ASSET__3866a8fd__"